import { Injectable } from '@angular/core';
import { capitalizeFirstLetter, getRandomId } from '@asamco/utils';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import swal, { SweetAlertOptions } from 'sweetalert2';

import { IFrameChildService } from './i-frame-child.service';
import { MessageType } from './message-type.enum';

@Injectable({
	providedIn: 'root',
})
export class LegacyIFrameMenuService {
	private map = new Map();

	constructor(private childService: IFrameChildService) {}

	modalOpen() {
		document.body.classList.add('modal-open');
		return this.send({
			action: 'modalOpen',
			payload: true,
		});
	}

	modalClose() {
		document.body.classList.remove('modal-open');
		return this.send({
			action: 'modalClose',
			payload: false,
		});
	}

	send(payload) {
		const actionId = getRandomId();
		if (payload.action === undefined) {
			throw new Error(`you can't call the sideMenu without an action`);
		}
		payload.actionId = actionId;
		const subject = new Subject<any>();
		this.map.set(actionId, subject);
		this.childService.send({ type: MessageType.sideMenu, payload });
		return subject.toPromise();
	}

	showSwal(options: SweetAlertOptions, defaultTitle = true): Promise<any> {
		this.modalOpen();

		// Default swal title
		if (defaultTitle) {
			let title = capitalizeFirstLetter(options.icon);
			switch (options.icon) {
				case 'error':
				case 'success':
				case 'warning': {
					title += '!';
					break;
				}
			}
			options.title = title;
		}

		return swal
			.fire(options)
			.then(result => {
				this.modalClose();
				return result;
			})
			.catch(obj => {
				this.modalClose();
				return obj;
			});
	}

	closeSwal() {
		this.modalClose();
		swal.close();
	}
}
